import React, { useState, useEffect } from 'react'
import { db } from './../Firebase'



function LastDate() {
    const [date, setDate] = useState(null)
    useEffect(() => {
        db.collection('Pruebas').doc('metadata')
            .onSnapshot(snapshot => {
                setDate(snapshot.data())
            }
            )
    }, [])
    return (
        <div style={{ fontWeight: 600 }}>
            {date && (<>
                Última fecha de actualización: {date.lastDate}</>)}
        </div>
    )
}

export default LastDate
